.ClientForm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ClientForm_row {
  display: flex;
  gap: 1rem;
}

.ClientForm_field {
  flex: 1;
}

.ClientForm_fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.ClientForm_legend {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.ClientForm_radioRow {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 0.5rem;
}
